<template>
    <div>
        <h1>Minnesota Nurse Aide Registry - Trigger Headmaster Import</h1>
        <div class="card">
            <div class="card-body">
                <b-row>
                    <b-col cols="6">
                        <BaseDateOfBirthInput v-model="request.startDate"
                                       :v="$v.request.startDate"
                                       slug="startDate"
                                       label="Start Date"
                                       setId="startDate"
                        />
                    </b-col>
                    <b-col cols="6">
                        <BaseDateOfBirthInput v-model="request.endDate"
                                       :v="$v.request.endDate"
                                       slug="endDate"
                                       label="End Date"
                                       setId="endDate"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="4">
                        <b-button type="button" variant="primary" @click="submitMn">Submit MN</b-button>
                        <b-button type="button" variant="primary" @click="submitMr">Submit MR</b-button>
                        <b-button type="button" variant="secondary" @click="clear">Clear</b-button>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from "axios"
    import axiosRetry from 'axios-retry'
    import {required} from 'vuelidate/lib/validators'
    import {toastService} from "@/mixins/toastService";
    import moment from 'moment';
    import BaseDateOfBirthInput from "@/components/templates/input/BaseDateOfBirthInput";

    axiosRetry(axios, {
        retries: 3,
        retryDelay: axiosRetry.exponentialDelay
    })

    export default {
        components:{
            BaseDateOfBirthInput
        },
        data() {
            return {
                request: {
                    startDate: null,
                    endDate: null
                }
            }
        },
        mixins: [
            toastService
        ],
        methods: {
            submitMn() {
                this.$v.$touch()
                    if(this.$v.$invalid){
                        toastService.showRootToast("Error", "Missing required fields.", "danger", this.$root)
                        return
                    }
                axios.post(`${process.env.VUE_APP_API_BASE_URL}/admin/mn-headmaster`, this.request)
                    .then(response => {
                        toastService.showRootToast("Success", "MN Server Headmaster import started.", "success")
                    })
            },
            submitMr() {
                this.$v.$touch()
                if(this.$v.$invalid){
                    toastService.showRootToast("Error", "Missing required fields.", "danger", this.$root)
                    return
                }
                axios.post(`${process.env.VUE_APP_API_BASE_URL}/admin/mr-headmaster`, this.request)
                    .then(response => {
                        toastService.showRootToast("Success", "MR Server Headmaster import started.", "success")
                    })
            },
            clear() {
                this.request = {
                    startDate: null,
                    endDate: null
                }
                this.$v.$reset()
            },
        },
        validations() {
            return {
                request: {
                    startDate: { required } ,
                    endDate: { required }
                }
            }
        },
        created() {
            document.title = "Trigger Headmaster Import - NAR"
        },
    }
</script>
